var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 1001,
    viewBox: "0 0 1001 1001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.539062,
    y: 0.0625,
    width: 999.997,
    height: 999.997,
    rx: 499.998,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.372 339.823L635.005 205.189L795.371 205.188L795.371 365.555L660.737 500.188L795.371 634.821L795.371 795.189L635.005 795.187L500.372 660.554L365.739 795.187L205.371 795.187L205.373 634.821L340.006 500.188L205.373 365.555L205.371 205.189L365.739 205.189L500.372 339.823ZM468.538 371.656L347.091 250.209L250.391 250.209L250.393 346.907L371.84 468.354L468.538 371.656ZM403.674 500.188L500.372 403.49L597.07 500.188L500.372 596.886L403.674 500.188ZM371.84 532.022L250.393 653.469L250.392 750.167L347.091 750.167L468.538 628.72L371.84 532.022ZM532.206 628.72L653.653 750.167L750.351 750.168L750.351 653.469L628.904 532.022L532.206 628.72ZM628.904 468.354L532.206 371.656L653.653 250.209L750.351 250.208L750.351 346.907L628.904 468.354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXfi);
export default __webpack_public_path__ + "static/media/xfi.d4b7fa0dd5add661f34e3c5de6f0df64.svg";
export { ForwardRef as ReactComponent };